import uScopeApi from 'uScope/js/public-api';
import {MarkAsRead} from './MarkAsRead';

uScopeApi.plugins.register({
  name: 'dst:mark-as-read',

  extends: 'viewport',

  dependencies: ['dst:wrapper'],

  constructor: MarkAsRead
});



// WEBPACK FOOTER //
// ./src/slide-tray/uScope-extensions/mark-as-read/index.js